const book_list = [
  {
    id: '157565',
    name: '传国功匠',
    zl_bid: '677942',
    description: '中国东南沿海瓯江流域，为了一个七十年前不同寻常的盟约，五家顶级瓯派（温州）匠工的传人在寻找秘笈《瓯宝图》过程中，与境外正邪两大力量之间发生殊死冲突及各派瓯越匠人之间颇有历史渊源的爱恨情仇的传奇。\n' +
      '【主要故事线索】：\n' +
      '1、中国瓯匠与上世纪来到中国的传教士订立了70年护宝盟约。\n' +
      '2、瓯匠传人为寻找《瓯宝图》以及“瓯宝”，与境外邪恶势力的生死夺宝。\n' +
      '3、瓯匠传人之间的几代人爱恨情仇以及与境外善恶两大力量的历史恩怨纠缠。\n' +
      '本书荣获2019优秀网络文学原创作品推介、2019扬子江原创网络文学大赛特别奖。',
    author: '陈酿',
    cate1_id: '283',
    word_count: '209056',
    cover: 'https://readstatic.zhulang.com/res/cover/157/565/157565_180.jpg?1600366955'
  },
  {
    id: '556886',
    name: '空战英豪：陈怀民传',
    zl_bid: '826033',
    description: '2025年是世界反法西斯战争胜利80周年，在2015年由民政部公布的第二批著名抗日英烈和英雄群体名录中有一位著名的镇江籍烈士，牺牲时年仅22岁的中国空军飞行员陈怀民。\n' +
      '陈怀民在4.29武汉空战时负伤，放弃跳伞，加速撞向日军王牌飞行员“红武士”高桥宪一，与敌同归于尽，极大地鼓舞了抗日军民的士气。周恩来总理为陈怀民题写挽联“义薄云天 捐躯报国”，朱德总司令称其为“精忠神勇”。\n' +
      '陈怀民是世界空战史上敢与于敌机对撞同归于尽的第一人，是中国空军从反法西斯战场一路走来，驰骋蓝天的军魂，鼓舞着一代代又一代代中国空军为守卫祖国的领空而舍生忘死！',
    author: '情殇孤月',
    cate1_id: '26',
    word_count: '368597',
    cover: 'https://readstatic.zhulang.com/res/cover/556/886/556886_180.jpg'
  },
  {
    id: '180777',
    name: '守鹤人',
    zl_bid: '778558',
    description: '2021年中国作家协会重点扶持项目。\n' +
      '作品围绕丹顶鹤这一国家一级保护动物，从护鹤人、爱鹤人、窥伺者、盗猎者的几方缠斗写起，通过一个保护丹顶鹤的惊心动魄而又感人至深的故事，使得人与自然、人与动物、人与环境之间的相互依赖、亲密无间的关系得以润物无声地阐释，情绪深沉，值得回味。',
    author: '吴半仙',
    cate1_id: '283',
    word_count: '352410',
    cover: 'https://readstatic.zhulang.com/res/cover/180/777/180777_180.jpg'
  },
  {
    id: '167736',
    name: '2.24米的天际',
    zl_bid: '717695',
    description: '一位海归“菜鸟”年轻姑娘，被中国排协邀请担任中国女排二队主教练，带领一群20岁出头的”二队“选手不忘初心为了梦想去奋斗。在危机之际，她们”接棒“中国女排，为了”升国旗、奏国歌“的誓言，为了传承”祖国至上、团结协作、顽强拼搏、永不言败“的女排精神，她们砥砺前行……\n' +
      '入选2020年中国作家协会重点扶持。',
    author: '行知',
    cate1_id: '56',
    word_count: '658239',
    cover: 'https://readstatic.zhulang.com/res/cover/167/736/167736_180.jpg?1600363756'
  },
  {
    id: '135742',
    name: '大明首相',
    zl_bid: '584367',
    description: '作者站在大历史维度，充分尊重历史真实，主要事件、人物不虚构、不美（丑）化，制度、风俗等细节还原历史原貌，以人性为底色，以朝廷为枢纽，塑造了给因袭萎靡、积弊丛生的老大王朝带来清明刚健新风，以忠诚、干净、担当著称，锐志匡时、肩大任而不挠的执政者的真实形象，揭开了帝制中国上层的神秘面纱，在错综复杂的矛盾纠葛中，全方位再现了大明中后期犹暗乍明、朦胧躁动的历史。小说情节曲折生动，人物性格鲜明，弥漫着浓厚、古雅的历史氛围，有很强的代入感，使人仿佛置身时空隧道，一览大明帝国的历史风景。\n' +
      '入选“2017年度中国作家协会重点作品扶持”项目',
    author: '维衡',
    cate1_id: '22',
    word_count: '927442',
    cover: 'https://readstatic.zhulang.com/res/cover/135/742/135742_180.jpg?1600368437'
  },
  {
    id: '556885',
    name: '江小年的二十四节气',
    zl_bid: '826031',
    description: '江小年是一个80后单亲妈妈，新年后的一天，她带着四岁的阿福从城市离婚回到稻香村，带着90多岁的太奶奶在南方村落度过了一段静谧且充实的时光。通过每天自给自足的耕种与烹饪，逐步治愈内心的创伤，二十四节气是农耕时节，在耕种与收获的循环中，慢慢与丈夫和解，把平凡的日子过成艺术。她以节气为经，农谚为纬，用酸坛里的微生物记录时光。当都市青年带着现代农业技术返乡，古法耕作智慧与山外人碰撞出星辰般的火花，二十四节气化作七十二道梯田年轮。',
    author: '懿小茹',
    cate1_id: '285',
    word_count: '322718',
    cover: 'https://readstatic.zhulang.com/res/cover/556/885/556885_180.jpg'
  },
  {
    id: '556138',
    name: '玉拂天阙',
    zl_bid: '825899',
    description: '扬州乐坊里，舞姬的胭脂染红了丝绸罗裙；洛阳道观中，青灯照映着画满符咒的黄纸。谁能想到，这个手持拂尘的女道士，日后会成为搅动大唐风云的利剑？\n' +
      '她本是喜爱骑马射箭的将门之女，却被命运逼成乐坊舞姬。嫁给盐商只为父亲那身紫色官服，从云端跌落凡尘，清净道心困于深宅大院。屡屡遭人陷害，在绝境中奋起反抗，却最终成为一无所有的弃妇。\n' +
      '渴望自由却沦为权贵玩物，想远离红尘，谁知安史之乱爆发，破碎的山河唤醒了她的热血豪情。\n' +
      '她脱下道袍，带领父兄旧部驰骋沙场。以道观为秘密据点传递军情，借舞姬身份刺杀叛军将领。曾经的霓裳羽衣舞化作杀人招式，开元观的符纸写满叛军的死期。洛阳城头，白衣染血的她挥动拂尘，最后一击如雷霆万钧。',
    author: '笑波客',
    cate1_id: '22',
    word_count: '690885',
    cover: 'https://readstatic.zhulang.com/res/cover/556/138/556138_180.jpg'
  },
  {
    id: '156202',
    name: '旷世烟火',
    zl_bid: '650769',
    description: '故事从1949年开始，以中国东南300里楠溪江流域第一大财主家新寡的徐大小姐为主人公，通过这位文弱女子大起大落的生活为背景，描写与她相关的各个历史背景下各个阶层的家族和社会人物， 展现一幅从新中国成立到“改革开放40年”共70年期间，中国东南大地——瓯江两岸的社会形象的历史画卷，由徐大小姐的生活线为脉络，史诗般展现温州这块神奇土地上各个社会阶层各种人物在各个特殊历史阶段的政治、经济、人文、风土和情感历程。《旷世烟火》将是一部偏重于感性和个人主义的家族史、风俗史以及个人命运的沉浮史，也将是一部浓缩性的东南大地新中国成立后的百姓命运史和心灵史。\n' +
      '【向新中国成立70周年献礼参赛作品】该作品获得2019年中国作家协会重点作品扶持、2019全国首届现实题材主题征文大赛未完结组一等奖、第三届中国“网络文学+”大会中被评为“年度十大影响力IP入围作品”。',
    author: '陈酿',
    cate1_id: '285',
    word_count: '497500',
    cover: 'https://readstatic.zhulang.com/res/admincover/156/202/156202_180.jpg?1582785903'
  },
  {
    id: '166300',
    name: '特别的归乡者',
    zl_bid: '737067',
    description: '大雨冲垮了小金河桥，老村支书前往省城找建筑商陈飞黄资助修桥，陈飞黄给了他五万块，可这笔钱根本不够修桥，老村支书不知道，其实陈飞黄早已破产。\n' +
      '陈飞黄出门躲债，在火车站遇到同乡猴子和二傻。二傻在建筑工地打工摔伤了腿，陈飞黄决定护送他回老家。\n' +
      '二傻腿伤严重，需要手术，陈飞黄指导猴子找包工头讨要赔偿金，猴子按照陈飞黄的方法，成功的要到了赔偿金，对陈飞黄崇拜不已。\n' +
      '老村支书为了修桥跌入河里，一病不起，猴子推荐陈飞黄当村支书，村干部得知陈飞黄破产的事，坚决反对，被老村支书说服。\n' +
      '从此以后，陈飞黄带领村民走上致富的道路……\n' +
      '入选2020年中国作家协会重点扶持。',
    author: '夜神翼',
    cate1_id: '285',
    word_count: '266167',
    cover: 'https://readstatic.zhulang.com/res/cover/166/300/166300_180.jpg?1600364008'
  },
  {
    id: '180773',
    name: '我的黄河我的城',
    zl_bid: '778492',
    description: '2021中国作家协会重点扶持项目\n' +
      '《我的黄河我的城》选取了中原大地上普通却具有代表性的邵氏一家为人物原型，通过这个四世同堂的家族对一个大时代中的众生和人性流变的勘察和描绘,书写了一段乡村至城市，小城市至大都市，从贫穷走向繁华的时代变迁史，淋漓尽致的表现出城市发展的轨迹。',
    author: '麦苏',
    cate1_id: '283',
    word_count: '491468',
    cover: 'https://readstatic.zhulang.com/res/cover/180/773/180773_180.jpg?1623431362'
  },
  {
    id: '528575',
    name: '江渔',
    zl_bid: '819036',
    description: '长江中的物种越来越稀少了，渔业的衰竭，也导致了整个生态系统被破坏，许多珍稀物种濒危，保护生态，保护长江渔业，已经成为迫在眉睫的事情。\n' +
      '　　渔民向来都是在水中靠水吃饭的，船就是他们移动的家。\n' +
      '　　为从根本上缓解长江生物资源衰退和生物多样性减少的危机，以习近平同志为核心的党中央从战略全局高度和长远发展角度，作出了自2020年1月1日0时起长江十年禁渔的重大决策。\n' +
      '然而，渔民们却对未来迷茫，对“洗脚上岸”之后的生活生存产生了不确定和恐惧心理，他们有的不愿意放弃祖辈传下来的捕鱼生活，有的对退渔上岸后的生活不确定而不愿意放弃渔船和捕鱼，姜瑜从武警退役之后，回到渔村，她决定改变这一切……',
    author: '煜素',
    cate1_id: '283',
    word_count: '271476',
    cover: 'https://readstatic.zhulang.com/res/cover/528/575/528575_180.jpg'
  },
  {
    id: '551433',
    name: '侠光向阳生',
    zl_bid: '824241',
    description: '国之大者，君为之任；侠之大者，为国为民。这是一个百岁老党员李廷魁的人生故事。李廷魁的一生充满了传奇色彩，他先后化身为战斗英雄、光明使者、报恩赤子和泽教老人，如同一根蜡烛照亮了别人燃烧了自己，将自己的一生无私地奉献给了国家、家乡和人民，唯独没有他自己。',
    author: '笑波客',
    cate1_id: '283',
    word_count: '230599',
    cover: 'https://readstatic.zhulang.com/res/cover/551/433/551433_180.jpg'
  },
  {
    id: '556139',
    name: '时光咖啡馆',
    zl_bid: '825844',
    description: '随着全球的老龄化加剧，帮助老人融入社会，缓解孤独感和老龄化带来的心理压力亟待展开，养老，成了我们最为忧心又不知如何解决的问题，老年人也是有快乐的需求，也是应该充满欢乐的，他们经历了那么多，他们的晚年生活更应该是充满经历过的通透感和幸福感的。\n' +
      '时光咖啡馆，不仅是一个消费场所，更是一个充满人文关怀的社交场所，在这里 ，有朝气蓬勃的年轻人辅助，有身材健朗的老年人发挥余热、成为咖啡馆的员工，他们的切身融入，让咖啡馆极具生活气息，老年人和年轻人不同群体之间的互动，帮助老人打破孤独，重塑与社会的联结，银发咖啡馆，不仅仅是一个场所，更是一种社会理念体现。',
    author: '煜素',
    cate1_id: '283',
    word_count: '445907',
    cover: 'https://readstatic.zhulang.com/res/cover/556/139/556139_180.jpg'
  },
  {
    id: '185714',
    name: '我的西海雄鹰翱翔',
    zl_bid: '780254',
    description: '1964年10月16日下午3时，新疆罗布泊上空升起蘑菇云，中国第一颗原子弹成功爆炸。自此，这个千年古国将不再受欺凌，世界为之震惊。然而，很少有人知道中国的第一颗原子弹是在神秘的金银滩草原诞生的。\n' +
      '这是一个为家国奉献青春的故事！',
    author: '懿小茹',
    cate1_id: '283',
    word_count: '589674',
    cover: 'https://readstatic.zhulang.com/res/cover/185/714/185714_180.jpg'
  },
  {
    id: '163181',
    name: '归时舒云化春雪',
    zl_bid: '723122',
    description: '人生就像是一条奔波向海，永不回头的河流，当你从源头走来，一路向海的时候，也许种种的支流会让人迷失方向。幸福与快乐也许看似遥遥无期，可在下一个转弯时，便会突然出现在你的面前。当江舒云走进武校的时候，她便开始了人生的选择，这选择或许只是出于无奈或者幻想，作为一个女人，她在生活的压力下，只能选择这种危险地方式来追求未来。但是压力和无奈并不意味着未来也是如此，当她住进602室的时候，命运似乎将她引入了另外一条支流，而这条支流将会为她带来什么样的改变，便是江舒云自己，都说不清，道不明，只有暗暗地欢喜藏在心中。作品荣获2019年河南省直文艺创作人员“深入生活、扎根人民”创作扶持，同时入选2019年度河南省作家协会重点扶持。',
    author: '麦苏',
    cate1_id: '285',
    word_count: '532630',
    cover: 'https://readstatic.zhulang.com/res/admincover/163/181/163181_180.jpg?1582780502'
  },
  {
    id: '152241',
    name: '荣光不会晚',
    zl_bid: '614271',
    description: '生活一向如此，你永远不知道明天和意外哪个会先来。\n' +
      '金雪，有丈夫，有孩子，知足而快乐，从没想过自己会转眼之间离婚，成为单亲妈妈。\n' +
      '安逸的生活被彻底打破，她几经辗转，找到了自己的方向。\n' +
      '南京泥人，是她童年的快乐和理想，更是祖父辈的老手艺，传统匠人行业凋敝，机缘巧合，金雪走上了改良、发扬和推广南京泥人的创业之路。\n' +
      '这条路荆棘密布，险象环生，可是她从来没有害怕过，反而越挫越勇。\n' +
      '第二次人生，充满迷茫和未知，可她从不畏惧挑战困难，挑战自己。\n' +
      '【向新中国成立70周年献礼参赛作品】获2019扬子江网络文学原创作品大赛优胜奖；2019全国首届现实题材主题征文大赛完结。',
    author: '朵朵麻',
    cate1_id: '285',
    word_count: '226528',
    cover: 'https://readstatic.zhulang.com/res/cover/152/241/152241_180.jpg?1600367711'
  },
  {
    id: '161856',
    name: '防线',
    zl_bid: '713369',
    description: '上市生物制药公司星和集团，被所在地原人大主任实名举报，存在严重的安全隐患。市安委办副主任科员袁来临时受命，深入该企业所在街道，以普通安巡员的身份，调查该案件，却发现该企业的隐患，不仅事关生产安全，还因基因编辑、生物实验等对城市公共安全有着巨大的影响。与此同时，他也在不知不觉中，被卷入了一场与新型犯罪分子的殊死较量中。\n' +
      '小说选取特区经济社会快速发展的某一特定时刻，以“安巡员”这一群体切入，塑造特区安监人的典型形象，他们视国家、人民利益为最高利益，当好安全卫士，为国家平安稳定而拼搏奋斗，为城市构筑了一道安全防线。',
    author: '阿北',
    cate1_id: '283',
    word_count: '395974',
    cover: 'https://readstatic.zhulang.com/res/cover/161/856/161856_180.jpg?1600365840'
  },
  {
    id: '25742',
    name: '河庄梦情',
    zl_bid: '388110',
    description: '（男主：白爷）作者立足于乡土，着眼于中国普通民众，着眼于爱国主义和革命情怀，用近乎白描的手法，全景式展现了民国后期中原大地上各行各业的人物。绘声绘色地讲述了当山河破碎、风雨飘摇之际，一群有正义有血性的中华好儿女，没有随遇而安，随波逐流，听任欺凌。他们历经爱恨情仇、人间冷暖、社会变迁，勇敢地拿起武器，奔走呼告，化解乡间矛盾、弥合国民内部矛盾，战土匪、收溃军、灭日寇、迎光明！\n' +
      '2018年该作品获得中国作家协会重点作品扶持，并且获得了2018年江苏省首届原创网络文学大赛优胜奖。',
    author: '笑波客',
    cate1_id: '283',
    word_count: '2290532',
    cover: 'https://readstatic.zhulang.com/res/admincover/025/742/25742_180.jpg?1582774206'
  },
  {
    id: '157436',
    name: '天梯',
    zl_bid: '664579',
    description: '仰望天空，我们关注的多是驾驶战鹰翱翔的“天之骄子”，但幕后还有一群守护战鹰的人， 他们与战鹰日夜相伴，朝夕相处；他们为战鹰望闻问切，诊病把脉；他们用双手架起天梯，托起一批批战鹰翱翔天际；他们是空军编成比例最大的一群人，也是空军中最默默无闻的一群人。他们是人民空军中一支极为特殊而神秘的群体——航空机务兵。\n' +
      '作者以一名普通技术干部的视角，以其成长历程为切入点，全景展示了空军机务官兵的苦与乐、血与泪，使命责任与信念坚守，同时也见证了人民空军近二十年由弱到强的辉煌历程。\n' +
      '【国内首部关于空军机务官兵的长篇小说】\n' +
      '向新中国成立70周年献礼参赛作品、献礼中国人民解放军空军建军七十周年！\n' +
      '2019扬子江网络文学原创作品优胜奖。',
    author: '扬帆星海',
    cate1_id: '283',
    word_count: '222355',
    cover: 'https://readstatic.zhulang.com/res/cover/157/436/157436_180.jpg?1665604093'
  },
  {
    id: '158828',
    name: '不负韶光',
    zl_bid: '693205',
    description: '十八大后，归国侨眷夏棘青因旧城区改造，和新小孜、谭鸣声、季陶然等年轻人因缘聚会在城郊综合社区东江新城。滞后的配套与服务让他心有抵触，成为在网络中挑剔问题的“毛毛虫”，微博与微信公众号“新城夜话”成为居民吐槽的负面平台。伴随城市文明建设与基层治理创新的深入，夏棘青不知不觉开始参与社区公益服务，与街坊邻里上演了许多啼笑皆非的故事，随后在基层党组织帮助和支持下，自觉创立”网络多媒体自治联盟”，与年轻伙伴们共同实现“八步蝶变”，描绘出爱情、亲情、友情的美丽画卷，展现改革创新进程中，党组织克难求进，关心引导新青年转变思维，积极投身社会治理，发展成为团青年先锋、文明好网民的真实轨迹。\n' +
      '江苏省2020年主题出版重点出版物选题、中国作家协会网络文学中心重点作品扶持。',
    author: '月壮边疆',
    cate1_id: '283',
    word_count: '899783',
    cover: 'https://readstatic.zhulang.com/res/cover/158/828/158828_180.jpg?1600366743'
  },
  {
    id: '180793',
    name: '锦绣青衣',
    zl_bid: '779690',
    description: '戏校毕业后，叶知秋尝到了毕业即失业的痛苦滋味。\n' +
      '启蒙老师眼里不可多得的大青衣、同学眼中天赋高肯努力的业务尖子，在残酷的现实面前，是那么渺小。\n' +
      '她不肯放弃，抓住一切可以抓住的机会，怀着对戏曲的满腔热爱，披荆斩棘，勇往直前，一步一步成长、蜕变，终成为名扬天下的一代名伶。',
    author: '雨墨倾心',
    cate1_id: '285',
    word_count: '211886',
    cover: 'https://readstatic.zhulang.com/res/cover/180/793/180793_180.jpg'
  },
  {
    id: '152285',
    name: '无字江山',
    zl_bid: '616247',
    description: '历史是一把刻尺，刻着贾湖刻符，刻着甲骨文，刻着小篆，也镌刻着无字的红山、仰韶、长江、黄河……\n' +
      '2019年中国作家协会网络文学中心重点扶持作品、辽宁网络文学“金桅杆”奖。',
    author: '小神',
    cate1_id: '285',
    word_count: '4136516',
    cover: 'https://readstatic.zhulang.com/res/admincover/152/285/152285_180.jpg?1582779918'
  },
  {
    id: '157415',
    name: '最后的村庄',
    zl_bid: '660109',
    description: '新世纪初，在城市化进程中，豫西九龙山区明清古村落——瓦罐村，人去村空，最后一户人家中九十七岁的老红军魏长庚和他的侄子魏石寨以及他们的忠实朋友老黄狗，一同守护着这里的好山好水和老祖先留下的古村落。在他们的努力下，不但守住了绿水青山，而且使这一古村落得到了开发利用，成为旅游胜地。然而，魏长庚老人却永远长眠于此……\n' +
      '本书获得2019扬子江原创网络文学大赛二等奖。【向新中国成立70周年献礼参赛作品】',
    author: '塬上草',
    cate1_id: '283',
    word_count: '323663',
    cover: 'https://readstatic.zhulang.com/res/cover/157/415/157415_180.jpg?1600367057'
  },
  {
    id: '185560',
    name: '茶魂',
    zl_bid: '785521',
    description: '一个居住在云南省西南边陲原始森林的古老部落，\n' +
      '一个神秘而又勤劳的民族——布朗族，\n' +
      '他们守护着两万八千亩古茶林，\n' +
      '他们是古老的制茶手艺传承者。\n' +
      '他们相信茶有茶魂，\n' +
      '秉承着人与自然和谐共存的纯朴理念，千百年来勤勉地劳作。\n' +
      '当政府“精准”扶贫的春风吹进这片古茶林，\n' +
      '茶农们发扬林下茶种植技术，逐步走上了致富的道路。\n' +
      '普洱茶走向了全国乃至全世界，\n' +
      '景迈山古茶林更是以它独特而突出的价值，申报2022世界遗产。\n' +
      '本书，是一部布朗族茶农们从贫困走向富裕的记录，\n' +
      '讲述布朗茶农的苦乐酸甜，烟火茶香的故事。\n' +
      '注：本书主角均以真人真事改编，主角均为真实姓名。\n' +
      '参考资料：《芒景布朗族与茶》《民族使者》',
    author: '素衣凝香',
    cate1_id: '283',
    word_count: '276045',
    cover: 'https://readstatic.zhulang.com/res/cover/185/560/185560_180.jpg?1630602450'
  },
  {
    id: '167739',
    name: '正义辩权',
    zl_bid: '719925',
    description: '本书取得2020年“广西玉林市文艺人才文艺精品项目扶持作品”荣誉。\n' +
      '在法律面前，无论你是贫穷或是富贵，人人都是平等的，正义永远站在法律的那一边。帅气律师与美女记者上演一场轰轰烈烈的正义追逐。',
    author: '我本纯洁',
    cate1_id: '283',
    word_count: '548957',
    cover: 'https://readstatic.zhulang.com/res/cover/167/739/167739_180.jpg?1726090011'
  },
  {
    id: '163997',
    name: '荣耀之上',
    zl_bid: '719711',
    description: '消防局紧急救援特别行动组组长向薇是退役军人，做事雷厉风行，做人风格强悍，自从最崇敬的队长兼爱人在一场大火之中牺牲之后，她藏起悲痛，成为这只无名英雄小队的队长。在这座城市内，每天都有大大小小的状况发生，城市救援队有应必回，使命必达。英雄永不会被遗忘，因为英雄的背后，还有人愿意继续负重前行，成为新的荣光。\n' +
      '【入选2020年度河南省精神文明建设“五个一工程”重点创作项目。】',
    author: '麦苏',
    cate1_id: '285',
    word_count: '500788',
    cover: 'https://readstatic.zhulang.com/res/cover/163/997/163997_180.jpg?1600364881'
  },
  {
    id: '152359',
    name: '盛开的米兰花',
    zl_bid: '618982',
    description: '刚毕业的师范生米兰，满怀信心的想成为一名优秀的教育工作者，可现实遇到了种种困难，她这朵刚刚绽放的米兰花，能否抵抗得住风吹雨打？是否能实现教育公平，推动教育改革，以及完善教育理念的理想？\n' +
      '【向新中国成立70周年献礼参赛作品】作品荣获2019扬子江原创网络文学大赛优胜奖；2019全国首届现实题材主题征文大赛完结组三等奖。',
    author: '炫炫',
    cate1_id: '285',
    word_count: '202910',
    cover: 'https://readstatic.zhulang.com/res/admincover/152/359/152359_180.jpg?1582952307'
  },
  {
    id: '180876',
    name: '传世琉璃',
    zl_bid: '783124',
    description: '世界琉璃看华夏，华夏琉璃看齐鲁，齐鲁琉璃看颜山。\n' +
      '故事围绕着郑、蒋两家的琉璃工坊，争夺琉璃极品鸡油黄非物质遗产继承人开始的。\n' +
      '自然谁是传承人两家明争暗斗，最后蒋家用手段把鸡油黄的非遗传承人争到了手，郑家一气之下撤出了琉璃行，谁会想到郑家早就有意另劈新路进了一字之差的玻璃行，看似蒋家成了琉璃王但是当站到顶峰时蒋家才知道了高处不胜寒，此时已经无法回头，蒋家在经过众多的事故后，也认识到了鸡油黄乃至古法琉璃的传承并不是一家独有，古法琉璃他是属于民族的，只有发扬壮大他才更炫丽。',
    author: '老宏',
    cate1_id: '283',
    word_count: '839546',
    cover: 'https://readstatic.zhulang.com/res/cover/180/876/180876_180.jpg?1621530303'
  },
  {
    id: '98287',
    name: '稔子花开',
    zl_bid: '526456',
    description: '穿百家衣吃百家饭的孤儿刘振华从名牌大学本科毕业后，拒绝省城大单位的橄榄枝，辜负心爱的女友，回到自己的家乡，鞠躬尽瘁回报家乡，立志要让落后山村脱贫，让村民的日子过得红红火火，但是……\n' +
      '该作品2018年获得广东省文化繁荣发展专项扶持项目、获得江苏省首届网络文学原创作品大赛二等奖。',
    author: '莫贤',
    cate1_id: '283',
    word_count: '253916',
    cover: 'https://readstatic.zhulang.com/res/cover/098/287/98287_180.jpg?1600370092'
  },
  {
    id: '36703',
    name: '黑白禁区',
    zl_bid: '439206',
    description: '本书重在弘扬我国我党的爱国主义建设，突出表现我军我公安干警的风采，揭开军人们鲜为人知的一面，和他们饱受着心理上的巨大压力。而当一个缉毒警察的痛点被一次次的击中，他的亲人，兄弟一次次的被灼伤，被摧残，他疯了，他一头撞进那个无法分辨黑白的禁区里，嘶吼着拼命前行，永无止境。\n' +
      '2018年中国作家协会重点扶持作品。由欧豪主演的本书同名当代缉毒刑侦网剧即将播出。',
    author: '东岳不苦',
    cate1_id: '283',
    word_count: '734794',
    cover: 'https://readstatic.zhulang.com/res/admincover/036/703/36703_180.jpg?1582774605'
  },
  {
    id: '152196',
    name: '刺猬小姐向前冲',
    zl_bid: '612251',
    description: '北漂，是林佳人生之中最勇敢的一次选择。\n' +
      '她从不惧怕未知的恐慌，只担心失去掌控人生的权利。\n' +
      '8岁到18岁，她苦练刺绣十年。\n' +
      '19岁到28岁，她成为投资集团独当一面的资深经理人。\n' +
      '人生却永远是一个圈，兜兜转转，回到最初。\n' +
      '29岁这一年，她重新捏起了针线，在底布上绣出了深邃宇宙，在职场绣出了华丽人生。\n' +
      '她终于明白，那个在某天踩着七彩祥云来救赎她的英雄， 一直是她自己。\n' +
      '这是一个外柔内刚的小女子从职场白领，蜕变成创业女王的故事。\n' +
      '很久以后，林佳才恍然，人生之中的每一次重要选择，都是在某个不起眼的午后，随意做出。\n' +
      '【向新中国成立70周年献礼参赛作品】作品荣获2019年度中原文艺精品创作工程重点项目扶持；2019全国首届现实题材主题征文大赛完结组二等奖。',
    author: '麦苏',
    cate1_id: '285',
    word_count: '428981',
    cover: 'https://readstatic.zhulang.com/res/admincover/152/196/152196_180.jpg?1582776269'
  },
  {
    id: '167614',
    name: '一条搜救犬的见证',
    zl_bid: '731548',
    description: '我叫大美，是一条有编号的搜救犬，我参加过许多的搜救工作，我从快要塌方的矿井下面把人拽出来，我在荒野里找到走丢了的老爷爷，我从桥洞下找到离家出走的孩子，我在孤岛上寻找到了摔晕的驴友，我还参加了一个民间救援队，由许多退伍老兵组建，我陪着他们一起成长，见证他们的勇敢、果断和大爱无畏，这是一支最优秀的救援队，我的训导员也是最优秀的，而我——大美，最优秀的搜救犬，不许反驳！',
    author: '煜素',
    cate1_id: '283',
    word_count: '621467',
    cover: 'https://readstatic.zhulang.com/res/cover/167/614/167614_180.jpg?1600363811'
  },
  {
    id: '151823',
    name: '维和先锋',
    zl_bid: '591207',
    description: '我叫肖强兵，一个远征北美战乱区的维和警察，戴上“地球与橄榄枝”肩章的刹那，维护和平、打击犯罪、传播华夏文化就成了我最大的追求……面对狂徒、灾难、战争王、阴谋家和各种圈套陷阱，我不是打不死的小强，只要我到达的地方，那里就会迎来光明和希望！\n' +
      '向新中国成立70周年献礼现实题材征文大赛参赛作品。',
    author: '蓝盔战歌',
    cate1_id: '283',
    word_count: '1661806',
    cover: 'https://readstatic.zhulang.com/res/admincover/151/823/151823_180.jpg?1582776181'
  },
  {
    id: '166287',
    name: '人间重晚晴',
    zl_bid: '731917',
    description: '尊敬老人，是中国文化的传统。可是，随着现代化进程不断加快，老年人生活不便问题越来越突出，传统的养老服务方式已呈现出严重的不适应。在未富先老的环境条件下，如何解决乡村养老服务问题，显得任重道远。\n' +
      '“天意怜幽草，人间重晚晴。”她克服重重困难，扭转了“只能居家养老”的传统观念，改善老人的生活条件和精神面貌，让老人获得幸福感。最终和同伴们一起携手，让老年人开出生活幸福之花。',
    author: '狐小妹',
    cate1_id: '285',
    word_count: '216286',
    cover: 'https://readstatic.zhulang.com/res/cover/166/287/166287_180.jpg?1600364015'
  },
  {
    id: '161984',
    name: '援外仁医',
    zl_bid: '712944',
    description: '知非是拥有绝对自信的胸外主治医生，为实现医术报国的夙愿主动请缨成为一名援非医生，修羽是出生中医世家的前全科医生，弃医从军的他是维和部队警卫分队少校中队长，当她和他在战争硝烟弥漫、疾病蔓延的扎维亚相遇，中医和西医在非洲这片土地上，碰撞出一个又一个精彩的火花。他们以精湛的医术和高尚的医德，赢得了受援国政府和人民的高度赞扬。',
    author: '桑甜',
    cate1_id: '61',
    word_count: '520974',
    cover: 'https://readstatic.zhulang.com/res/cover/161/984/161984_180.jpg?1600365774'
  },
  {
    id: '167615',
    name: '我的草原星光璀璨',
    zl_bid: '732039',
    description: '故事以青藏高原的腹地三江源地区为背景，讲述牧区脱贫遇到的苦难与问题，全景式展现了高原牧区脱贫攻坚的壮阔画卷。通过描写第一书记蓝堇时的蜕变，全景式地书写当下牧区人民的生活、理想和追求。\n' +
      '女主人公蓝堇时在江源村艰难而温暖地度过无数个日日夜夜，在生存环境艰苦的草原，用酥油灯照亮跋涉的荆棘，参与新时代的草原巨变，把民族文化、民族产业融入互联网的多种脱贫模式，寻求三江源生态保护与脱贫攻坚的平衡点，解决牧区妇女就业问题等人生历程，以女性视角表达对母亲河源头的生灵的敬畏与青藏高原上的生命礼赞！\n' +
      '入选2020年中国作家协会网络文学中心重点作品扶持。',
    author: '懿小茹',
    cate1_id: '285',
    word_count: '313038',
    cover: 'https://readstatic.zhulang.com/res/cover/167/615/167615_180.jpg?1600363810'
  },
  {
    id: '175941',
    name: '冰魂',
    zl_bid: '751149',
    description: '辗瑞雪为土，凝洁冰为魂。\n' +
      '以冰为主要材料来雕刻的艺术形式，在我国已经有了数百年的历史。\n' +
      '这是一部见证着冰雕行业兴衰的小说，\n' +
      '描绘新老冰雕艺术家们的苦乐酸甜。\n' +
      '本书以冰雪艺术家孟献国、王海峰两位老师真实经历改编。\n' +
      '特别鸣谢：\n' +
      '哈尔滨市职工摄影家协会',
    author: '素衣凝香',
    cate1_id: '283',
    word_count: '259613',
    cover: 'https://readstatic.zhulang.com/res/cover/175/941/175941_180.jpg'
  },
  {
    id: '170802',
    name: '刺猬的微光',
    zl_bid: '741065',
    description: '邵凌霜毕业没几年就面临着一个重要的难题：母亲过世之后，同母异父的脑瘫弟弟的归宿在她的生活当中引起了轩然大波。\n' +
      '爱心组织的牵头人姜源是一个“怀柔”的人，他极力探寻着自己的价值，工资积蓄都用在了特殊儿童救助之上，因此一直未婚。\n' +
      '邵凌霜与姜源在“相亲局”上狭路相逢，她对弟弟所引发的后续问题焦头烂额，但姜源的介入恰到好处的给了邵凌霜一抹微光。\n' +
      '至此，邵凌霜开始寻找自己的价值，她决定与姜源站在一起，一同见证了多个深陷泥潭的家庭里的酸甜苦辣，她也真正爱上了那一群被时光所遗忘的孩子。',
    author: '大橙子',
    cate1_id: '283',
    word_count: '302025',
    cover: 'https://readstatic.zhulang.com/res/cover/170/802/170802_180.jpg?1600362792'
  },
  {
    id: '543488',
    name: '陪伴之路',
    zl_bid: '822753',
    description: '妈妈的一场手术，让江藜深深的思考了独生子女的陪伴和养老的问题。她放弃了创业三年的公司，毅然回到家乡通城，一边照顾妈妈一边和闺蜜小伙伴们一起研究市场，一起寻找新的生存方式。\n' +
      '最终，经过分析考察，江藜决定从事陪诊师行业。\n' +
      '江藜说：“当下社会，各行各业内卷严重，市场饱和，而社会老龄化问题严重，二胎三胎家庭生活压力变化，年轻的一群人生存压力增加，养老和抚养孩子的社会矛盾愈发尖锐，陪诊师的出现，可以从一定程度上缓解医患之间的矛盾，排队难，挂号难，等待难，操作难等等问题，更从生活上和心理上，给与了病患和家属抚慰，使得他们能够更好的投入工作，能够更安心的为生活而拼搏，为家庭而继续努力。”',
    author: '煜素',
    cate1_id: '283',
    word_count: '232678',
    cover: 'https://readstatic.zhulang.com/res/cover/543/488/543488_180.jpg'
  },
  {
    id: '164014',
    name: '亲爱的，二进制',
    zl_bid: '724530',
    description: '5G时代，海归女胥姝英国归来，投身AI研发，与麻省理工学院人工智能王子叶通并肩面对人工智能、大数据、云计算黑科技年代风起云涌。技术封锁、商海暗斗、贸易争端、感情纠葛，大戏接踵而至。姝姝和叶通笑看风云，突破技术壁垒，让安防机器人、语音机器人、售货机器人惊艳呈现，让“中国设计”在国际舞台完美彰显。作品为2020年上海文化艺术资助项目。',
    author: '唐墨',
    cate1_id: '61',
    word_count: '211392',
    cover: 'https://readstatic.zhulang.com/res/cover/164/014/164014_180.jpg?1600364869'
  }
]

const cate_map = {
  "1": "修真武侠",
  "2": "传统武侠",
  "3": "古典仙侠",
  "4": "现代仙侠",
  "5": "武侠幻想",
  "6": "玄幻小说",
  "7": "东方玄幻",
  "8": "西方魔幻",
  "9": "异界争霸",
  "10": "现代魔法",
  "11": "洪荒史诗",
  "12": "现代修真",
  "13": "异能奇书",
  "14": "黑暗幻想",
  "15": "动漫游戏",
  "16": "武侠同人",
  "17": "影视同人",
  "18": "动漫同人",
  "19": "游戏同人",
  "21": "小说同人",
  "22": "历史小说",
  "23": "历史传记",
  "24": "穿越历史",
  "25": "架空历史",
  "26": "军事小说",
  "27": "战争幻想",
  "28": "军旅生涯",
  "29": "谍战特工",
  "30": "都市小说",
  "31": "都市生活",
  "32": "热血成长",
  "33": "都市异能",
  "34": "娱乐明星",
  "35": "青春校园",
  "36": "职场商战",
  "37": "科幻小说",
  "38": "未来世界",
  "39": "宇宙争霸",
  "40": "古武机甲",
  "41": "未世进化",
  "42": "时空穿梭",
  "43": "超级科技",
  "44": "网游小说",
  "45": "游戏生涯",
  "46": "电子竞技",
  "47": "虚拟网游",
  "48": "游戏异界",
  "50": "推理",
  "51": "推理悬念",
  "52": "恐怖惊悚",
  "53": "灵异鬼怪",
  "54": "风水秘术",
  "55": "探险异闻",
  "56": "竞技体育",
  "57": "体育竞技",
  "58": "篮球运动",
  "59": "足球运动",
  "60": "棋牌桌游",
  "61": "现代言情",
  "62": "都市情缘",
  "63": "总裁豪门",
  "64": "婚恋家庭",
  "65": "职场白领",
  "66": "异术超能",
  "67": "娱乐巨星",
  "68": "古代言情",
  "69": "古代情缘",
  "70": "穿越架空",
  "71": "女尊权谋",
  "72": "宫闱宅斗",
  "73": "经商种田",
  "74": "古代历史",
  "75": "浪漫青春",
  "76": "青春校园",
  "77": "禁忌绝恋",
  "78": "百合之恋",
  "79": "原创耽美",
  "80": "同人耽美",
  "81": "玄幻异能",
  "82": "玄幻异世",
  "83": "奇幻魔法",
  "84": "悬疑",
  "85": "推理探案",
  "86": "惊悚恐怖",
  "87": "灵异志怪",
  "88": "神秘文化",
  "89": "古墓迷踪",
  "90": "武侠仙侠",
  "91": "仙侠奇缘",
  "92": "古典仙侠",
  "93": "洪荒封神",
  "94": "动漫游戏",
  "95": "女生同人",
  "96": "换身入替",
  "97": "萌系小说",
  "99": "古装",
  "100": "武侠",
  "101": "言情",
  "102": "伦理",
  "103": "都市",
  "104": "职场",
  "106": "古典名著",
  "107": "现代名著",
  "108": "社科科普",
  "109": "经管励志",
  "111": "国外青春文学",
  "112": "港台青春文学",
  "113": "韩国青春文学",
  "114": "爱情情感",
  "115": "校园",
  "116": "叛逆成长",
  "118": "外文小说",
  "119": "情感小说",
  "120": "官场职场",
  "121": "文史传记",
  "122": "宗教哲学",
  "123": "生活随笔",
  "125": "各国历史",
  "126": "通俗说史",
  "127": "文物考古",
  "128": "地方史志",
  "129": "史家专著",
  "130": "历史随笔",
  "132": "历史人物",
  "133": "人物集合",
  "134": "艺术家",
  "135": "法律人物",
  "136": "宗教人物",
  "137": "女性人物",
  "139": "婚姻",
  "140": "性知识",
  "141": "婚恋综合",
  "142": "恋爱",
  "143": "育儿",
  "145": "政治理论",
  "146": "中国政治",
  "147": "世界政治",
  "148": "外交国际关系",
  "149": "各国政治",
  "150": "公共管理",
  "151": "政党读物",
  "156": "军事史",
  "159": "其他",
  "160": "其他",
  "161": "其他",
  "162": "其他",
  "163": "职场商战",
  "165": "青年文学",
  "166": "青年文摘",
  "167": "短篇",
  "168": "都市小说",
  "169": "玄幻科幻",
  "170": "灵异悬疑",
  "171": "武侠仙侠",
  "172": "历史军事",
  "173": "同人小说",
  "174": "其他",
  "175": "短篇",
  "176": "总裁豪门",
  "177": "婚恋职场",
  "178": "穿越架空",
  "179": "宫斗宅斗",
  "180": "悬疑灵异",
  "181": "浪漫青春",
  "182": "其他",
  "183": "都市情感",
  "184": "婚姻与家庭",
  "185": "2018年",
  "186": "2015年",
  "187": "2016年",
  "188": "2017年",
  "189": "2018年",
  "190": "体育健康",
  "191": "足球周刊",
  "192": "玄幻",
  "193": "都市",
  "194": "恐怖",
  "195": "校园",
  "196": "悬疑",
  "197": "科幻",
  "198": "生活",
  "199": "热血",
  "200": "爆笑",
  "201": "纯爱",
  "202": "历史",
  "203": "少儿",
  "204": "动作",
  "205": "战争",
  "206": "彩虹",
  "207": "萌系",
  "208": "穿越",
  "209": "后宫",
  "210": "唯美",
  "211": "玄幻",
  "212": "都市",
  "213": "恐怖",
  "214": "校园",
  "215": "悬疑",
  "216": "科幻",
  "217": "生活",
  "218": "热血",
  "219": "爆笑",
  "220": "纯爱",
  "221": "历史",
  "222": "少儿",
  "223": "动作",
  "224": "战争",
  "225": "彩虹",
  "226": "萌系",
  "227": "穿越",
  "228": "后宫",
  "229": "唯美",
  "230": "古风",
  "231": "古风",
  "232": "魔幻",
  "233": "魔幻",
  "234": "治愈",
  "235": "治愈",
  "236": "武侠",
  "237": "武侠",
  "238": "知音",
  "239": "故事传奇",
  "240": "山海经",
  "241": "2018",
  "242": "2017",
  "246": "2016",
  "247": "2018",
  "248": "2017",
  "249": "今古传奇故事版",
  "250": "2018",
  "251": "2017",
  "252": "2016",
  "253": "今古传奇单月号",
  "254": "2017",
  "255": "2018",
  "256": "2018",
  "257": "2017",
  "258": "2016",
  "259": "2018",
  "260": "2017",
  "261": "2016",
  "262": "2015",
  "263": "经典武侠",
  "264": "金庸全集",
  "265": "梁羽生全集",
  "266": "古龙精选",
  "267": "经典言情",
  "268": "琼瑶精选",
  "269": "青春文学",
  "270": "经典名著",
  "271": "古典名著",
  "272": "外国名著",
  "273": "近代名家",
  "274": "健康心灵",
  "275": "保健养生",
  "276": "宗教哲学",
  "277": "生活随笔",
  "278": "当代文学",
  "279": "长篇小说",
  "280": "科幻",
  "281": "历史小说",
  "282": "都市职人",
  "283": "现实",
  "284": "现实",
  "285": "现实",
  "286": "现实",
  "287": "经典读本",
  "288": "经管励志",
  "289": "军事谍战",
  "290": "人文社科",
  "291": "诗歌散文",
  "292": "商战权谋",
  "293": "影视传奇",
  "294": "纪实文学",
  "295": "名人传记"
}

export {book_list, cate_map}



// WEBPACK FOOTER //
// ./src/module/active_26423/books.js